import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { confirmarAsistenciaTurno } from "../../../actions/turnos/agenda";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { FormularioCoseguro } from "./FormularioCoseguro";
import { PagoCoseguro } from "./PagoCoseguro";
import { useDispatch } from "react-redux";
import { fetchMediosPago } from "../../../actions/cbos/medioPago";
import { getValorizacionesCtaCoseguro } from '../../../actions/coseguros/coseguros';

export const ModalCoseguro = (props) => {
  const dispatch = useDispatch();

  const [esPantallaFormulario, setEsPantallaFormulario] = useState(true);
  const [openConfirmar, setOpenConfirmar] = useState(false);

  useEffect(() => {
    dispatch(fetchMediosPago());
  }, [dispatch]);

  const handleCloseAlert = () => {
    setOpenConfirmar(false);
    props.onClose();
  };

  const turnoDemanda = props.usuarioTurnoSeleccionado?.especialidad?.practicasDemanda;

  const handleSendConfirmarAsistencia = () => {
    dispatch(confirmarAsistenciaTurno(props.usuarioTurnoSeleccionado?.idAgenda, true));
    setOpenConfirmar(false);
    props.onClose();
  };

  useEffect(() => {
    if(props.openDemandaLaboratorio && turnoDemanda){
      getValorizacionDemanda();
    }      
  }, [props.openDemandaLaboratorio, turnoDemanda]);

  const getValorizacionDemanda = () => {
    dispatch(
      getValorizacionesCtaCoseguro(
        props.usuarioTurnoSeleccionado.idAgenda,
        setEsPantallaFormulario,
        setOpenConfirmar
      )
    );

    setEsPantallaFormulario(false);
  }

  return (
    <Dialog
      fullWidth
      maxWidth={esPantallaFormulario ? "lg" : "sm"}
      open={props.open}
      style={{height: !esPantallaFormulario&& 700, marginTop: -25}}
      // onClose={props.onClose}
      aria-labelledby="form-dialog-title"
    >
      {openConfirmar && (
        <AlertFinalizadoStepper
          open={openConfirmar}
          pregunta={`Confirmar Asistencia al Turno`}
          dialogText={`Quiere proceder con la Confirmación de Asistencia al turno?`}
          buttonCancel={"Cancelar"}
          buttonSubmit={"Confirmar"}
          handleClose={handleCloseAlert}
          handleSend={handleSendConfirmarAsistencia}
        />
      )}
      <DialogTitle id="form-dialog-title">
        <h2
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "0",
          }}
        >
          <Typography variant="h6">
            {`Co-Seguro: ${
              esPantallaFormulario ? "Ingreso de Practicas" : "Confirmar Pago"
            }`}
          </Typography>
          <Typography variant="h6">
            {props.usuarioTurnoSeleccionado?.afiliado?.apellido_y_nombre}
          </Typography>
        </h2>
      </DialogTitle>
      <DialogContent>
        {esPantallaFormulario ? (
          <FormularioCoseguro
            setEsPantallaFormulario={setEsPantallaFormulario}
            setOpenPracticasHandler={props.setOpenPracticasHandler}
            usuarioTurnoSeleccionado={props.usuarioTurnoSeleccionado}
            setOpenConfirmar={setOpenConfirmar}
            closeModalCoseguro={props.onClose}
            desdeBotonAux={props.desdeBotonAux}
            idAgenda={props.usuarioTurnoSeleccionado?.idAgenda}
            checkConfirmado={props.checkConfirmado}
            idObraSocial={props.idObraSocial}
            turnoDemanda={turnoDemanda}
            getValorizacionDemanda={getValorizacionDemanda}
            cargaDefaultPractica={props.cargaDefaultPractica}
          />
        ) : (
          <PagoCoseguro
            setEsPantallaFormulario={setEsPantallaFormulario}
            setOpenDemandaLaboratorio={props.setOpenDemandaLaboratorio}
            usuarioTurnoSeleccionado={props.usuarioTurnoSeleccionado}
            closeModalCoseguro={props.onClose}
            idObraSocial={props.idObraSocial}
            idProfesional={props.idProfesional}
            openDemandaLaboratorio={props.openDemandaLaboratorio}
            turnoDemanda={turnoDemanda}
            fecha={props.fecha}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
